define('services/googleanalytics',['require','utils'],function (require) {
    'use strict';
    var utils = require('utils');
    return {
        /**
         * exposes a "track" function that console logs what's being tracked and also calls ga with the function arguments
         * for parameters, see https://developers.google.com/analytics/devguides/collection/analyticsjs/events?hl=en
         */
        init: function () {
            window.gaTrack = $.proxy(function() {
                var args = Array.prototype.slice.call(arguments);
                args = ['send', 'event'].concat(args);
                this._logGaCall.apply(window, args);
                if (window.ga != null) {
                    window.ga.apply(window, args);
                }
            }, this);
        },

        /**
         * When single page app changes page, set our analytics object and log a page view
         * more info for SPA analytic tracking: https://developers.google.com/analytics/devguides/collection/analyticsjs/single-page-applications
         * @param {string} hash 
         */
        logPageView: function (hash, title) {
            var page = '/' + hash;
            console.log('Tracking Google Page: ' + page);
            if (window.ga != null) {
                window.ga('set', { page: page, title: title });
                window.ga('send', 'pageview');
            }
        },

        _logGaCall: function() {
            var params = [];
            for (var i = 0, length = arguments.length; i < length; i++) {
                params.push(arguments[i]);
            }
            console.log('Tracking Google Event: ' + params.join(', '));
        },

        PROFILE_ID: 64172317, //found in admin portal > view settings: https://www.google.com/analytics/web/?hl=en#management/Settings/a34297308w62555952p64172317/%3Fm.page%3DProfileSettings/
        CLIENT_ID: '445422974445-14rtpi0u388gnpk9rotoqi2u1n5arp74.apps.googleusercontent.com', //TODO: depending on what this is, consider inserting into webconfig

        /**
         * Loads the google anlaytics api in (if it's not already loaded) to do custom analytics viewing
         * Note that "window.gapi" will become available
         * Check out the docs for more info: https://developers.google.com/analytics/devguides/reporting/embed/v1/devguide 
         * For info on setup/oauth: https://developers.google.com/api-client-library/javascript/start/start-js#Setup
         * To check usage and quotas: https://console.developers.google.com/project/445422974445/apiui/apiview/analytics/usage?duration=PT1H
         * @param {function} callback is called when gapi is ready
         */
        _loadApi: function () {
            var promise = $.Deferred();
            if (window.gapi == null) {
                (function (w, d, s, g, js, fjs) {
                    g = w.gapi || (w.gapi = {});
                    g.analytics = { q: [], ready: function (cb) { this.q.push(cb); } };
                    js = d.createElement(s);
                    fjs = d.getElementsByTagName(s)[0];
                    js.src = 'https://apis.google.com/js/platform.js';
                    fjs.parentNode.insertBefore(js, fjs);
                    js.onload = function () { g.load('analytics'); };
                }(window, document, 'script'));

                window.gapi.analytics.q.push(promise.resolve);
                return promise;
            } else {
                promise.resolve();
            }
            return promise;
        },

        /**
         * Make the user authorize via OAuth to query google analytics
         * @param {Func} callback 
         * @return {Promise}
         */
        _authorize: function () {
            var promise = $.Deferred();
            this._loadApi().then(function() {
                window.gapi.analytics.ready(function() {
                    window.gapi.analytics.auth.authorize({
                        container: 'auth-button',
                        clientid: this.CLIENT_ID
                    });
                    window.gapi.analytics.auth.on('success', promise.resolve);
                }.bind(this));
            }.bind(this));
            return promise;
        },

        /**
         * Tries running the query. If the response indicates we need to be authenticated, do that and try the query again.
         * Query Builder Tool: https://ga-dev-tools.appspot.com/query-explorer/
         * @param {object} query
         * @return {Promise}
         */
        queryApi: function (query) {
            return this._loadApi().then(function() {
                return window.gapi.client.analytics.data.ga.get(query)
                    .then(function(response) {
                        return response;
                    }, function(err) {
                        if (err.status === 401) {
                            console.log('Authorizing and trying again...');
                            this._authorize().then(function() {
                                return this.queryApi(query);
                            }.bind(this));
                        }
                    }.bind(this));
            }.bind(this));
        },

        /**
         * Get the unique page hits for all the customers.
         * Note that this gets hits to the customers' shorturls, setenrollmentinfo.aspx, 
         * and also a few miscellaneous pages that count as a hit for a particular customer.
         * @param {Array<{customerid,shorturl}>} customers 
         * @param {Date} from 
         * @param {Date} to 
         * @returns {Object} returns the raw results from analytics and also the new customers data source augmented with google analytics uniquehits data
         */
        getCustomerHits: function (from, to, customers) {
            return this.queryApi({
                'ids': 'ga:' + this.PROFILE_ID,
                'start-date': from,
                'end-date': to, //TODO: hook up to whenever johngrid is databound...
                'metrics': 'ga:uniquepageviews', // 'ga:pageviews',
                'dimensions': 'ga:pagePath',
                'filters': 'ga:pagePath=@cid=' //TODO: bring down distinct customer pages and add them as OR (separate by commas: https://developers.google.com/analytics/devguides/reporting/core/v3/reference?hl=en#filters)
            }).then(function (response) {
                //extract customerid from pagePath and hook it to pageviews in a dictionary
                var rows = utils.tryGetValue(response, 'result.rows');
                if (Array.isArray(rows)) {
                    var customerUniqueViews = rows.map(function (row) {
                        var page = row[0];
                        var uniqueViews = parseInt(row[1]);
                        //TODO; first check if the page is in any of the customerpages, else parse out cid value, else add to list of errors and console.error them
                        var customerId = parseInt(/setEnrollmentInfo.aspx\?cid\=(\d+)/i.exec(page)[1]); //TODO: match setenrollmentinfo.aspx OR default.aspx...
                        return { c: customerId, views: uniqueViews };
                    }); //TODO: group by c, select sum views, make groupBy in array utils whose call back will pass the group...hmmm
                    return customerUniqueViews;
                }
                return null;
            }, this.onApiError);
        },

        /**
         * Handler for when a google analytics api request fails
         * @param {} err 
         * @returns {} 
         */
        onApiError: function(err) {
            console.log(err);
        }
    };
});

